import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { EmailIcon, LockIcon } from '../components/Icons/Icons';
import './Auth.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Login functionality will be implemented with backend');
    console.log({ email, password });
  };

  return (
    <div className="auth-page">
      <Header />

      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Welcome Back</h1>
            <p>Sign in to your PakMilkiyat account</p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email Address</label>
              <div className="input-with-icon">
                <EmailIcon size={20} color="#636e72" />
                <input
                  type="email"
                  placeholder="your.email@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Password</label>
              <div className="input-with-icon">
                <LockIcon size={20} color="#636e72" />
                <input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" />
                <span>Remember me</span>
              </label>
              <button
                type="button"
                className="link-btn"
                onClick={() => window.navigateTo && window.navigateTo('forgot-password')}
              >
                Forgot Password?
              </button>
            </div>

            <button type="submit" className="btn-auth-primary">
              Sign In
            </button>

            <div className="auth-divider">
              <span>or</span>
            </div>

            <button type="button" className="btn-auth-secondary">
              Continue with Google
            </button>

            <div className="auth-footer">
              <p>
                Don't have an account?{' '}
                <button
                  type="button"
                  className="link-btn"
                  onClick={() => window.navigateTo && window.navigateTo('signup')}
                >
                  Sign Up
                </button>
              </p>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Login;
